"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PassStyle;

var React = _interopRequireWildcard(require("react"));

var _BoardingPass = _interopRequireDefault(require("./BoardingPass"));

var _Coupon = _interopRequireDefault(require("./Coupon"));

var _EventTicket = _interopRequireDefault(require("./EventTicket"));

var _Generic = _interopRequireDefault(require("./Generic"));

var _StoreCard = _interopRequireDefault(require("./StoreCard"));

var _usePkpass = require("../usePkpass");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function PassStyle() {
  var pass = (0, _usePkpass.usePkpass)();

  switch (pass.passStyle) {
    case 'boardingPass':
      return /*#__PURE__*/React.createElement(_BoardingPass.default, null);

    case 'coupon':
      return /*#__PURE__*/React.createElement(_Coupon.default, null);

    case 'eventTicket':
      return /*#__PURE__*/React.createElement(_EventTicket.default, null);

    case 'generic':
      return /*#__PURE__*/React.createElement(_Generic.default, null);

    case 'storeCard':
      return /*#__PURE__*/React.createElement(_StoreCard.default, null);

    default:
      return /*#__PURE__*/React.createElement("div", null, "Unsupported pass style");
  }
}
//# sourceMappingURL=PassStyle.js.map